import React from 'react';
import styled from 'styled-components';

const PikaIconSpanContainer = styled.span`
  color: ${props => (props.color ? props.color : 'inherit')};
  &::before {
    vertical-align: middle;
  }
`;

export interface PikaIconProps {
  className?: string;
  icon: string;
  title?: string;
  color?: string;
}

export const PikaIcon: React.FC<PikaIconProps> = ({
  className,
  icon,
  title,
  color,
}) => {
  return (
    <PikaIconSpanContainer
      title={title ?? ''}
      className={`${className ?? ''} ${icon}`}
      color={color ?? ''}
    />
  );
};
